<script lang="ts" setup>
import RModal from '~/components/organs/Modal.vue'
import { DESKTOP_WIDTH } from '~/static/window-sizing'
import videojs from 'video.js'
import 'video.js/dist/video-js.min.css'

const windowWidth = ref(DESKTOP_WIDTH)

const updateWindowWidth = () => {
  windowWidth.value = window.innerWidth
}

const playerEl: Ref = ref(null)

onMounted(() => {
  updateWindowWidth()
  window.addEventListener('resize', updateWindowWidth)
  videojs(playerEl.value, {})
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', updateWindowWidth)
})

const modalWidth = computed(() => {
  if (windowWidth.value >= DESKTOP_WIDTH) {
    return 887
  }
  return undefined
})

const videoWidth = computed(() => {
  if (windowWidth.value >= DESKTOP_WIDTH) {
    return 853
  }
  return windowWidth.value - 24
})

const videoHeight = computed(() => {
  return Math.round(videoWidth.value * 167 / 296)
})

</script>

<template>
  <RModal
    name-modal="generationsGuide"
    :width="modalWidth"
  >
    <template #header>
      <h5
        class="modal-title fs-5"
        id="subscribeModalLabel"
      >
        Инструкция
      </h5>
    </template>

    <template #body>
      <div
        class="body"
        :style="{
          width: videoWidth + 'px',
        }"
      >
        <div
          class="loading-area"
          :style="{
            height: videoHeight + 'px',
          }"
        >
          <div
            class="spinner-border"
            role="status"
          />
        </div>
        <video
          ref="playerEl"
          id="instruction-player"
          class="video-js"
          controls
          autoplay
          preload="auto"
          data-setup="{}"
          :width="videoWidth"
          :height="videoHeight"
        >
          <source
            :src="'/vod/instruction.mp4/index.m3u8'"
            type="application/x-mpegURL"
          >
        </video>
      </div>
    </template>
  </RModal>
</template>

<style lang="scss" scoped>
.body {
  min-height: rem(174px);
  padding-bottom: rem(32px);
  position: relative;

  iframe {
    position: relative;
    z-index: 1;
  }
}

.modal-body {
  min-height: rem(174px);
  padding-bottom: rem(32px);
}

.spinner-border {
  color: $indigo-500;
}

.loading-area {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  background: $indigo-100-light;
  margin-bottom: rem(16px);
  position: absolute;
  z-index: 0;
}
</style>
